/** Shared booking-stage strip. One UI, two products. */

export const HOTEL_ONLY_STAGES = [
  { id: "results", label: "תוצאות" },
  { id: "detail", label: "בחירת חדר" },
  { id: "passengers", label: "נוסעים" },
  { id: "payment", label: "תשלום" },
];

export const UNIFIED_FH_STAGES = [
  { id: "results", label: "תוצאות" },
  { id: "detail", label: "טיסות ומלון" },
  { id: "passengers", label: "נוסעים" },
  { id: "payment", label: "ביצוע תשלום" },
];

export function bookingProductKind(source) {
  if (source === "hotel" || source === "flightHotel") return source;
  if (source?.hotelsOnly === true || source?.productType === "hotels_only") return "hotel";
  return "flightHotel";
}

export function stagesForBookingProduct(product, activeId) {
  const stages = bookingProductKind(product) === "hotel" ? HOTEL_ONLY_STAGES : UNIFIED_FH_STAGES;
  const activeIdx = stages.findIndex((stage) => stage.id === activeId);
  return stages.map((stage, index) => ({
    ...stage,
    active: stage.id === activeId,
    done: activeIdx > index,
    stub: false,
  }));
}

/**
 * @param {"detail"|"passengers"|"payment"} activeId
 */
export function stagesForUnifiedFlightHotel(activeId) {
  return stagesForBookingProduct("flightHotel", activeId);
}
